import {
  Button,
  DialogActions,
  DialogContent,
  Grid2 as Grid,
  Paper,
  Switch,
  Typography,
} from "@mui/material";
import { acceptAllCookies, rejectAllCookies } from "../../../utils/helper";
import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { useDispatch } from "react-redux";
import { Cookies } from "react-cookie";

const cookiesType = [
  { name: "essentialCookies", text: "Essential Cookies (required)" },
  { name: "analyticsCookies", text: "Analytics Cookies" },
  { name: "functionalCookies", text: "Functional Cookies" },
  { name: "marketingCookies", text: "Marketing Cookies" },
];

function ManageCookie() {
  const dispatch = useDispatch();
  const cookie = new Cookies();

  // Handle cookie preference
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    const formData = Object.fromEntries(form);
    Object?.keys(formData)?.forEach((key, i) => {
      const oneYear = 365 * 24 * 60 * 60;

      cookie.set(key, "accepted", { path: "/", maxAge: oneYear });
    });
    dispatch(hideDialog());
  };

  return (
    <Paper component="form" onSubmit={handleSubmit}>
      <DialogContent
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        {cookiesType?.map((cooki, i) => (
          <Grid
            key={i}
            container
            mb={i === cookiesType?.length - 1 ? 0 : 1}
            spacing={1}
            alignItems="center"
          >
            <Grid size={{ xs: "grow" }}>
              <Typography variant="body2" fontWeight="500" color="other.color1">
                {cooki?.text}
              </Typography>
            </Grid>
            <Grid size={{ xs: "auto" }}>
              {i === 0 ? (
                <>
                  <Typography
                    fontSize={14}
                    fontWeight="600"
                    color="primary.dark"
                  >
                    Always Active
                  </Typography>
                  <Switch
                    sx={{ display: "none" }}
                    checked
                    variant="cookie"
                    name={cooki?.name}
                    disableRipple
                  />
                </>
              ) : (
                <Switch variant="cookie" name={cooki?.name} disableRipple />
              )}
            </Grid>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions
        sx={{
          gap: 1,
          button: { ml: "0 !important" },
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "center" },
        }}
      >
        <Button
          size="small"
          type="button"
          color="primary"
          variant="contained"
          onClick={() => {
            acceptAllCookies();
            dispatch(hideDialog());
          }}
          sx={{
            flexGrow: "1",
            justifyContent: "center",
          }}
        >
          Accept All
        </Button>
        <Button
          type="button"
          size="small"
          color="error"
          variant="outlined"
          onClick={() => {
            rejectAllCookies();
            dispatch(hideDialog());
          }}
          sx={{
            flexGrow: "1",
            justifyContent: "center",
          }}
        >
          Reject All
        </Button>
        <Button
          size="small"
          type="submit"
          color="dark"
          variant="outlined"
          sx={{ justifyContent: "center" }}
        >
          Save my Preferences
        </Button>
      </DialogActions>
    </Paper>
  );
}

export default ManageCookie;
